<template>
  <div ref="monitoringContent" class="parking-management container-with-collapsible-tree-sidebar">
    <!--侧边栏-->
    <app-tree-side :isOpen="treeSideBarOpen" :autoResizeBorder="true" @toggle="toggleTreeSideBar">
      <div class="general-container">
        <el-input class="search-input"
                  v-model="treeNodeFilter"
                  placeholder="请输入区域名称"
                  clearable>
          <img slot="prefix" src="@/assets/img/icon_search.png">
        </el-input>
      </div>
      <el-tree
        class="mt5"
        ref="tree"
        :data="treeData"
        :props="defaultTreeProps"
        :default-expanded-keys="treeExpandedKeys"
        :expand-on-click-node="false"
        node-key="key"
        highlight-current
        :filter-node-method="filterTreeNode"
        @node-click="handleTreeNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
      </el-tree>
    </app-tree-side>
    <!--卡片数据-->
    <div class="col-2">
      <!--等信息内容-->
      <div class="general-container">
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
          <el-tab-pane label="道闸列表" name="0" class="node-list-page">
            <el-form ref="queryForm" class="pagination-table-query-form" :inline="true"
                     @keyup.enter.native="handleFormQuery()">
              <el-form-item>
                <el-button @click="handleFormQuery()" type="primary">刷 新</el-button>
              </el-form-item>
              <el-form-item style="float:right">
                <span>总数</span><el-badge class="mark" :value="pageTotalCount" type="primary"/>
                <span>正常</span><el-badge class="mark" :value="pageNormalCount" type="success"/>
                <span>离线</span><el-badge class="mark" :value="pageErrorCount" type="info"/>
              </el-form-item>
            </el-form>
            <div class="general-container">
              <div ref="cardContianer" class="card-container">
                <!--最大为2行-->
                <el-row style="margin-bottom: 10px" v-for="(rowItem, rowIndex) in cardMaxRowCount" :key="rowItem">
                  <!--每行最大为4列-->
                  <el-col :span="24/cardMaxColCount" v-for="(colItem, colIndex) in cardMaxColCount" :key="colItem" :offset="0">
                    <el-card class="node-card" v-show="rowIndex*cardMaxColCount + colIndex < cardData.length">
                      <div slot="header" @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;">
                        <span class="card-header-title" :class="cardData.length > rowIndex*cardMaxColCount + colIndex && cardCurrentItem === cardData[rowIndex*cardMaxColCount + colIndex] ? 'active':''">
                          {{cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].name : ''}}
                        </span>
                        <span style="float: right;height: 30px;line-height: 30px;font-size: 16px" :class="cardData.length > rowIndex*cardMaxColCount + colIndex && cardData[rowIndex*cardMaxColCount + colIndex].letPass === 2 ? 'alarm-color':'normal-color'">
                          {{cardData.length > rowIndex*cardMaxColCount + colIndex ? getNameById(cardData[rowIndex*cardMaxColCount + colIndex].letPass, $type.diLetPasss):''}}
                        </span>
                      </div>
                      <div class="card-body-content" @click="cardCurrentItem = cardData[rowIndex*cardMaxColCount + colIndex];">
                        <div class="image-block">
                          <el-image :src="cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].pictureUrl:''">
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                        </div>
                      </div>
                      <div class="card-body-footer">
                        <span class="license-number" :class="cardData.length > rowIndex*cardMaxColCount + colIndex && cardData[rowIndex*cardMaxColCount + colIndex].licenseNumber !== '无车辆' ? 'normal-color':'offline-color'">
                          {{cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex].licenseNumber:'无车辆'}}
                        </span>
                        <div>
                          <span style="height:50%;vertical-align:middle">{{cardData.length > rowIndex*cardMaxColCount + colIndex ? getNameById(cardData[rowIndex*cardMaxColCount + colIndex].vehicleKind, $type.vehicleKinds):''}}</span><br>
                          <span style="height:50%;vertical-align:middle">{{cardData.length > rowIndex*cardMaxColCount + colIndex ? strDateTimeFromSTime_t(cardData[rowIndex*cardMaxColCount + colIndex].happenTime):''}}</span>
                        </div>
                        <el-button type="primary" class="footer-button" @click="cardCurrentItem = cardData.length > rowIndex*cardMaxColCount + colIndex ? cardData[rowIndex*cardMaxColCount + colIndex]:null;handleBgControl();">
                          放行
                        </el-button>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
              </div>
              <el-pagination
                background
                @current-change="handleCurrentPageChange"
                :current-page.sync="cardQueryParams.pageNum"
                :page-size.sync="cardQueryParams.pageSize"
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next, jumper"
                :total="cardTotalItem">
              </el-pagination>
              <el-tabs ref="realEventContianer" class="real-event-container">
                <el-tab-pane label="实时监控" name="0" class="pagination-table-container">
                  <el-table :data="realEventTableData"
                            ref="realEventTable"
                            border highlight-current-row
                            v-loading="loading"
                            element-loading-background="rgba(255, 255, 255, 0.8)"
                            element-loading-spinner="el-icon-loading"
                            element-loading-text="努力加载中..."
                            style="max-height: 160px;min-height: 160px;overflow: auto;"
                            @selection-change="handleRealEventTableSelectionChange"
                            @current-change="handleRealEventTableCurrentChange">
                    <!--          <el-table-column type="selection" width="40"></el-table-column>-->
                    <el-table-column label="序号" type="index" width="60"></el-table-column>
                    <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">
                      <template slot-scope="scope">{{ getNameById(scope.row.regionId, $globalData.regions) }}</template>
                    </el-table-column>
                    <el-table-column label="道闸名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="车牌号" prop="licenseNumber" width="100"></el-table-column>
                    <el-table-column label="车辆类型" prop="vehicleKind" width="100">
                      <template slot-scope="scope">{{ getNameById(scope.row.vehicleKind, $type.vehicleKinds) }}</template>
                    </el-table-column>
                    <el-table-column label="车主" prop="personName" width="100"></el-table-column>
                    <el-table-column label="部门" prop="departmentName" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="卡号" prop="cardNum" width="100"></el-table-column>
                    <el-table-column label="方向" prop="direction" width="100">
                    <template slot-scope="scope">{{ getNameById(scope.row.direction, $type.diDirections) }}</template>
                    </el-table-column>
                    <el-table-column label="操作类型" prop="letPass" width="100">
                      <template slot-scope="scope">{{ getNameById(scope.row.letPass, $type.diLetPasss) }}</template>
                    </el-table-column>
                    <el-table-column label="通行时间" prop="happenTime" width="160">
                      <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.happenTime)}}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="120">
                      <template slot-scope="scope">
                        <el-button
                          class="col-btn"
                          type="text"
                          icon="el-icon-view"
                          @click="handleRealEventView(scope.row)"
                        >查看
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-tab-pane>
          <el-tab-pane label="进出记录" name="1">
            <!-- form-item右对齐，标签宽度为70px -->
            <el-form ref="historyEventQueryForm" class="pagination-table-query-form" label-position="right" label-width="70px" :inline="true"
                     @keyup.enter.native="handleHistoryEventFormQuery()">
              <el-form-item label="车牌号">
                <el-input v-model="historyEventTableQueryParams.licenseNumber" placeholder="请输入车牌号"></el-input>
              </el-form-item>
              <el-form-item label="车主">
                <el-input v-model="historyEventTableQueryParams.personName" placeholder="请输入车主"></el-input>
              </el-form-item>
              <el-form-item label="部门名称">
                <el-input v-model="historyEventTableQueryParams.departmentName" placeholder="请输入部门名称"></el-input>
              </el-form-item>
              <el-form-item label="进出方向">
                <el-select v-model="historyEventTableQueryParams.direction" placeholder="请选择进出方向">
                  <el-option v-for="(item, index) in diDirectionsIncludeAll"
                             :key="'direction' + index"
                             :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="进出时间">
                <uni-date-range-picker
                  v-model="historyEventDates"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </uni-date-range-picker>
              </el-form-item>
              <el-form-item>
                <el-button @click="handleHistoryEventFormQuery()" type="primary">查 询</el-button>
                <el-button @click="resetHistoryEventQueryForm()">重 置</el-button>
              </el-form-item>
            </el-form>
            <div class="pagination-table-container">
              <el-table :data="historyEventTableData"
                        ref="historyEventTable"
                        border highlight-current-row
                        v-loading="loading"
                        element-loading-background="rgba(255, 255, 255, 0.8)"
                        element-loading-spinner="el-icon-loading"
                        element-loading-text="努力加载中..."
                        style="width: 100%"
                        @selection-change="handleHistoryEventTableSelectionChange"
                        @current-change="handleHistoryEventTableCurrentChange">
                <!--          <el-table-column type="selection" width="40"></el-table-column>-->
                <el-table-column label="序号" type="index" width="60"></el-table-column>
                <el-table-column label="区域" prop="regionId" :show-overflow-tooltip="true">
                  <template slot-scope="scope">{{ getNameById(scope.row.regionId, $globalData.regions) }}</template>
                </el-table-column>
                <el-table-column label="道闸名称" prop="resourceName" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="车牌号" prop="licenseNumber" width="100"></el-table-column>
                <el-table-column label="车辆类型" prop="vehicleKind" width="100">
                  <template slot-scope="scope">{{ getNameById(scope.row.vehicleKind, $type.vehicleKinds) }}</template>
                </el-table-column>
                <el-table-column label="车主" prop="personName" width="100"></el-table-column>
                <el-table-column label="部门" prop="departmentName" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="卡号" prop="cardNum" width="100"></el-table-column>
                <el-table-column label="方向" prop="direction" width="100">
                  <template slot-scope="scope">{{ getNameById(scope.row.direction, $type.diDirections) }}</template>
                </el-table-column>
                <el-table-column label="操作类型" prop="letPass" width="100">
                  <template slot-scope="scope">{{ getNameById(scope.row.letPass, $type.diLetPasss) }}</template>
                </el-table-column>
                <el-table-column label="通行时间" prop="happenTime" width="160">
                  <template slot-scope="scope"> {{strDateTimeFromSTime_t(scope.row.happenTime)}}</template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button
                      class="col-btn"
                      type="text"
                      icon="el-icon-view"
                      @click="handleHistoryEventView(scope.row)"
                    >查看
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination v-show="historyEventTableTotalRow > historyEventTableQueryParams.pageSize"
                             background
                             @current-change="handleHistoryEventCurrentPageChange"
                             @size-change="handleHistoryEventPageSizeChange"
                             :current-page.sync="historyEventTableQueryParams.pageNum"
                             :page-sizes="[5, 10, 15, 20, 30, 50, 100]"
                             :page-size.sync="historyEventTableQueryParams.pageSize"
                             prev-text="上一页"
                             next-text="下一页"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="historyEventTableTotalRow">
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!--显示告警事件信息-->
    <show-alarm-event v-if="showRealEventModalOpen" :modalOpen="showRealEventModalOpen" :alarmEvent="realEventTableCurrentRow" @submit="handleShowRealEventModalSubmit" @cancel="handleShowRealEventModalCancel"></show-alarm-event>

    <!--显示告警事件信息-->
    <show-alarm-event v-if="showHistoryEventModalOpen" :modalOpen="showHistoryEventModalOpen" :alarmEvent="historyEventTableCurrentRow" @submit="handleShowHistoryEventModalSubmit" @cancel="handleShowHistoryEventModalCancel"></show-alarm-event>

  </div>
</template>

<script type="text/ecmascript-6">
import ParkingManagement from './ParkingManagement.js'

export default ParkingManagement
</script>

<style lang="scss">
  @import "ParkingManagement.scss";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/parkingManagement/ParkingManagement.vue